import React, { useState } from "react";
import Link from "../LocalizedLink";
import LanguageSelector from "./LanguageSelector";
import logo from "../../images/shared/varbla-pk-logo.jpg";
import getNavTree from "./navigation";
import "./header.scss";
import { useTranslate } from "../../i18n/LanguageProvider";

const Header = ({ location }) => {
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const translate = useTranslate();
  const navTree = getNavTree(translate);

  return (
    <div className="header">
      <nav className="navbar is-fixed-top">
        <div className="container">
          <div className="navbar-brand">
            <Link className="navbar-item" to="/" style={{ padding: "0" }}>
              <img src={logo} alt="Logo" style={{ maxHeight: "70px" }} />
            </Link>
            <span
              role="navigation"
              className={`navbar-burger burger${
                mobileMenuActive ? " is-active" : ""
              }`}
              data-target="navbarMenu"
              onClick={() => setMobileMenuActive(!mobileMenuActive)}
            >
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>

          {mobileMenuActive && (
            <div className="navbar-dropdown">
              {navTree.map(page => (
                <Link
                  to={page.route}
                  key={page.title}
                  className={`navbar-item${
                    page.route === location ? " is-active" : ""
                  }`}
                >
                  {page.title}
                </Link>
              ))}
            </div>
          )}

          <div id="navbarMenu" className="navbar-menu">
            <div className="navbar-end">
              {navTree.map(page =>
                page.subPages ? (
                  <NavItemWithDropdown key={page.title} {...page} />
                ) : (
                  <NavItem key={page.title} {...page} />
                )
              )}
              <LanguageSelector />
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

const NavItem = ({ title, route }) => {
  return (
    <div className="navbar-item">
      <Link to={route} activeClassName="is-active">
        {title}
      </Link>
    </div>
  );
};

const NavItemWithDropdown = ({ title, route, subPages }) => {
  return (
    <div className="navbar-item has-dropdown is-hoverable">
      <Link to={route} activeClassName="is-active" className="navbar-link">
        {title}
      </Link>

      <div className="navbar-dropdown">
        {subPages.map(page => (
          <Link
            key={page.title}
            to={page.route}
            activeClassName="is-active"
            className="navbar-item"
          >
            {page.title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Header;
